export default __webpack_public_path__ + "static/media/service_award_message_icon.971efe09.svg";